import React from 'react';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: '#113d6e' }} className="text-white pt-5 pb-3 mt-5">
      <div className="container">
        <div className="row text-center text-md-start">

          <div className="col-md-6 mb-4">
            <div className="d-flex align-items-start gap-3">
              <img 
                src="/images/logofs.png" 
                alt="Freshskills Logo"
                width="100"
                height="100"
                style={{ objectFit: 'contain' }}
              />

              <div>
                <h5 className="fw-bold mb-1">About Freshskills</h5>
                <p className="small mb-0">
                  Freshskills provides expert-led training programs with dedicated placement support to accelerate professional growth and empower career success across tech and non-tech domains.
                </p>
                <p className="small mb-0">
                  Email:<a href="mailto:info@freshskills.co" className='text-light'> <strong>info@freshskills.co</strong></a>
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <h5 className="fw-bold">Quick Links</h5>
            <ul className="list-unstyled small">
              <li><a href="https://freshskills.co/about/" className="text-white text-decoration-none" target="_blank" rel="noopener noreferrer">About Us</a></li>
              <li><a href="https://freshskills.co/all-courses/" className="text-white text-decoration-none" target="_blank" rel="noopener noreferrer">Our Courses</a></li>
              <li><a href="https://freshskills.co/contact/" className="text-white text-decoration-none" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
            </ul>
          </div>

          <div className="col-md-3 mb-4">
            <h5 className="fw-bold">Follow Us</h5>
            <div className="d-flex justify-content-center justify-content-md-start gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <img src="/icons/facebook.svg" className="white-svg" alt="Facebook" width="20" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <img src="/icons/twitter.svg" className="white-svg" alt="Twitter" width="20" />
              </a>
              <a href="https://www.linkedin.com/company/freshskill/" target="_blank" rel="noopener noreferrer">
                <img src="/icons/linkedin.svg" className="white-svg" alt="LinkedIn" width="20" />
              </a>
            </div>
          </div>

        </div>

        <hr className="border-light" />

        <div className="text-center small">
          &copy; {year} Freshskills. All rights reserved.
        </div>
      </div>
    </footer>
  );
}